/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FrameworkRadarAxisDto } from './FrameworkRadarAxisDto';
import {
    FrameworkRadarAxisDtoFromJSON,
    FrameworkRadarAxisDtoFromJSONTyped,
    FrameworkRadarAxisDtoToJSON,
    FrameworkRadarAxisDtoToJSONTyped,
} from './FrameworkRadarAxisDto';

/**
 * 
 * @export
 * @interface FrameworkRadarDto
 */
export interface FrameworkRadarDto {
    /**
     * 
     * @type {string}
     * @memberof FrameworkRadarDto
     */
    frameworkSlug?: string;
    /**
     * 
     * @type {Array<FrameworkRadarAxisDto>}
     * @memberof FrameworkRadarDto
     */
    axes?: Array<FrameworkRadarAxisDto>;
}

/**
 * Check if a given object implements the FrameworkRadarDto interface.
 */
export function instanceOfFrameworkRadarDto(value: object): value is FrameworkRadarDto {
    return true;
}

export function FrameworkRadarDtoFromJSON(json: any): FrameworkRadarDto {
    return FrameworkRadarDtoFromJSONTyped(json, false);
}

export function FrameworkRadarDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrameworkRadarDto {
    if (json == null) {
        return json;
    }
    return {
        
        'frameworkSlug': json['frameworkSlug'] == null ? undefined : json['frameworkSlug'],
        'axes': json['axes'] == null ? undefined : ((json['axes'] as Array<any>).map(FrameworkRadarAxisDtoFromJSON)),
    };
}

export function FrameworkRadarDtoToJSON(json: any): FrameworkRadarDto {
    return FrameworkRadarDtoToJSONTyped(json, false);
}

export function FrameworkRadarDtoToJSONTyped(value?: FrameworkRadarDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'frameworkSlug': value['frameworkSlug'],
        'axes': value['axes'] == null ? undefined : ((value['axes'] as Array<any>).map(FrameworkRadarAxisDtoToJSON)),
    };
}

